module.exports = __webpack_public_path__ + "7ad599fa780d6244d784ed05b024f934.woff2";